import { makeStyles } from "@material-ui/core";

export const useTagsTreeModalStyles = makeStyles((theme) => ({
	dataTypeOfTree: {
		width: "25px",
		height: "25px",
		color: "white",
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		cursor: "pointer",
		border: "1px black solid",
	},
	root: {
		alignItems: "center",
		display: "flex",
		height: "32px",
	},
	customNodeRoot: {
		listStyleType: "none",
		margin: 0,
		padding: 0,
		"&:hover": {
			backgroundColor: "#f2f2f2",
		},
	},
	arrow: {
		alignItems: "center",
		cursor: "pointer",
		display: "flex",
		height: "24px",
		justifyContent: "center",
		width: "24px",
		transition: "transform linear 0.1s",
		transform: "rotate(0deg)",
	},

	"arrow > div": {
		alignItems: "center",
		display: "flex",
	},

	"arrow.is-open": {
		transform: "rotate(90deg)",
	},

	filetype: {
		display: "flex",
	},

	label: {
		paddingInlineStart: "8px",
	},

	selected: {
		backgroundColor: "#e8f0fe",
	},

	dragging: {
		opacity: 0.5,
	},
	contextMenu: {
		fontSize: "14px",
		backgroundColor: "#fff",
		borderRadius: "2px",
		padding: "5px 10px;",
		width: "140px",
		height: "auto",
		margin: "0",
		position: "fixed",
		boxShadow: "0 0 20px 0 #ccc",
		display: "flex",
		flexDirection: "column",
	},

	storyRoot: {
		display: "grid",
		height: "100%",
		gridTemplateRows: "auto 1fr",
		listStyleType: "none !important",
	},

	assetRoot: {
		boxSizing: "border-box",
		height: "100%",
		padding: "32px",
	},

	dropTarget: {
		boxShadow: "0 0 0 1px #1967d2 inset",
		borderRadius: "1px",
		backgroundColor: "#DAE4F2",
	},
	customDragRoot: {
		alignItems: "center",
		backgroundColor: "#1967d2",
		borderRadius: "4px",
		boxShadow:
			" 0 12px 24px -6px rgba(0, 0, 0, .25); 0 0 0 1px rgba(0, 0, 0, .08)",
		color: "#fff",
		display: "inline-grid",
		fontSize: "14px",
		gap: "8px",
		gridTemplateColumns: "auto auto",
		padding: "4px 8px",
		pointerEvents: "none",
	},

	icon: {
		alignItems: "center",
		display: "flex",
	},
	customDragLabel: {
		alignItems: "center",
		display: "flex",
	},
}));
